/* ==========================================================================
   BM custom: scroll hints (arrows) only when there is something to scroll
   Used by:
     - Product family rows (Ring style / Gemstone / Shape / ...):
         .product-family__cart-drawer-upsell  (arrows = ::before / ::after in component-product-family.css)
     - Engraving symbol rows:
         .bm-symbol-picker__rail-wrap         (arrow = .bm-symbol-picker__rail-indicator)
   Adds to the wrapper:
     bm-hints-ready         - JS has measured (until then the arrows show as before)
     bm-can-scroll-left     - content hidden on the left  -> show the left arrow
     bm-can-scroll-right    - content hidden on the right -> show the right arrow
   Styles: assets/bm-scroll-hints.css
   ========================================================================== */
(function () {
  'use strict';

  if (window.bmScrollHints) return; // loaded by more than one snippet - run once
  window.bmScrollHints = true;

  // wrapper selector -> the element inside it that actually scrolls
  var TARGETS = [
    { wrap: '.product-family__cart-drawer-upsell', scroller: '.cart-drawer-upsell__track' },
    { wrap: '.bm-symbol-picker__rail-wrap', scroller: '.bm-symbol-picker__rail' }
  ];
  var TOLERANCE = 2; // px - ignore sub-pixel rounding

  function update(wrap, scroller) {
    var max = scroller.scrollWidth - scroller.clientWidth;
    wrap.classList.toggle('bm-can-scroll-left', scroller.scrollLeft > TOLERANCE);
    wrap.classList.toggle('bm-can-scroll-right', max - scroller.scrollLeft > TOLERANCE);
    wrap.classList.add('bm-hints-ready');
  }

  function bind(wrap, scroller) {
    if (wrap.hasAttribute('data-bm-hints')) return;
    wrap.setAttribute('data-bm-hints', '');

    var run = function () { update(wrap, scroller); };
    scroller.addEventListener('scroll', run, { passive: true });
    window.addEventListener('resize', run);
    // Lazy images change the row width once they load
    Array.prototype.forEach.call(scroller.querySelectorAll('img'), function (img) {
      if (!img.complete) img.addEventListener('load', run);
    });
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(run);
      ro.observe(scroller);
      Array.prototype.forEach.call(scroller.children, function (child) { ro.observe(child); });
    }
    run();
  }

  function init() {
    TARGETS.forEach(function (t) {
      Array.prototype.forEach.call(document.querySelectorAll(t.wrap), function (wrap) {
        var scroller = wrap.querySelector(t.scroller);
        if (scroller) bind(wrap, scroller);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
})();
